import { useBannerAdOpen } from '@wt/game/providers/bannerAdOpen/BannerAdOpenProvider';
import { useUserProvider } from '@wt/game/providers/user/UserProvider';
import { useMemo } from 'react';

// Desktop only
export const ArchiveSidebarAd = () => {
  const { user } = useUserProvider();
  const { adOpen } = useBannerAdOpen();

  if (user.isPremium) {
    return <></>;
  }

  const top = useMemo(() => {
    return adOpen ? 'top-[166px]' : 'top-[80px]';
  }, [adOpen]);

  return (
    <div
      className={`absolute left-0 ${top} hidden desktop:flex desktop:h-[600px]`}
    >
      <div id="adngin-archive_sidebar-0"></div>
    </div>
  );
};
